export default "__VITE_ASSET__dad0fb68__"